export class Component {
    constructor(container) {
        this.container = container;
        // Учитывайте что код в конструкторе исполняется ДО всех объявлений в дочернем классе
    }
    toggleClass(element, className, force) {
        element.classList.toggle(className, force);
    }
    setText(element, value) {
        if (element) {
            element.textContent = String(value);
        }
    }
    setDisabled(element, state) {
        if (element) {
            if (state)
                element.setAttribute('disabled', 'disabled');
            else
                element.removeAttribute('disabled');
        }
    }
    setHidden(element) {
        element.style.display = 'none';
    }
    setVisible(element) {
        element.style.removeProperty('display');
    }
    setImage(element, src, alt) {
        if (element) {
            element.src = src;
            if (alt) {
                element.alt = alt;
            }
        }
    }
    render(data) {
        Object.assign(this, data !== null && data !== void 0 ? data : {});
        return this.container;
    }
}
